<template>
  <div class="express">
    <div class="express__title">
      <FlashSVG /> <span>Você está assistindo a um Workshop</span>
    </div>
    <div class="express__content">
      Vídeos de menor duração com dicas pontuais ou abordagem de assuntos introdutórios de alta relevância. <router-link target="_blank" :to="{ name: 'support', hash: '#faq-14' }">Saiba mais.</router-link>
    </div>
  </div>
</template>

<script>
import FlashSVG from '@/components/svg/FlashSVG'

export default {
  components: {
    FlashSVG,
  }
}
</script>
<style lang="scss" scoped>
.express {
  background: #ededed;
  padding: 16px;
  border-radius: 8px;
  border-bottom: 2px solid #e0e0e0;

  &__title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 8px;

    svg { width: 22px }
  }
}
</style>